import style from "../../variables.module.scss";

export { BellHasNotificationIcon } from "./BellHasNotification";

export const LogoIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18ZM18.0834 20.5583C21.401 15.8667 21.5474 13.0233 18.0834 8C14.5532 13.1305 15.0083 15.8499 18.0834 20.5583ZM16.5071 26.6697C17.0344 20.9478 15.7396 18.4122 10.228 15.7939C9.73599 22.0021 11.4898 24.1297 16.5071 26.6697ZM19.6803 26.6697C19.153 20.9478 20.4479 18.4122 25.9595 15.7939C26.4514 22.0021 24.6977 24.1297 19.6803 26.6697Z"
      fill={style.mainTextColor}
    />
  </svg>
);

export const GridIcon = ({ color }: { color?: "green" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2.5H3.83333C3.36662 2.5 3.13327 2.5 2.95501 2.59083C2.79821 2.67072 2.67072 2.79821 2.59083 2.95501C2.5 3.13327 2.5 3.36662 2.5 3.83333V7C2.5 7.46671 2.5 7.70007 2.59083 7.87833C2.67072 8.03513 2.79821 8.16261 2.95501 8.24251C3.13327 8.33333 3.36662 8.33333 3.83333 8.33333H7C7.46671 8.33333 7.70007 8.33333 7.87833 8.24251C8.03513 8.16261 8.16261 8.03513 8.24251 7.87833C8.33333 7.70007 8.33333 7.46671 8.33333 7V3.83333C8.33333 3.36662 8.33333 3.13327 8.24251 2.95501C8.16261 2.79821 8.03513 2.67072 7.87833 2.59083C7.70007 2.5 7.46671 2.5 7 2.5Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1667 2.5H13C12.5333 2.5 12.2999 2.5 12.1217 2.59083C11.9649 2.67072 11.8374 2.79821 11.7575 2.95501C11.6667 3.13327 11.6667 3.36662 11.6667 3.83333V7C11.6667 7.46671 11.6667 7.70007 11.7575 7.87833C11.8374 8.03513 11.9649 8.16261 12.1217 8.24251C12.2999 8.33333 12.5333 8.33333 13 8.33333H16.1667C16.6334 8.33333 16.8667 8.33333 17.045 8.24251C17.2018 8.16261 17.3293 8.03513 17.4092 7.87833C17.5 7.70007 17.5 7.46671 17.5 7V3.83333C17.5 3.36662 17.5 3.13327 17.4092 2.95501C17.3293 2.79821 17.2018 2.67072 17.045 2.59083C16.8667 2.5 16.6334 2.5 16.1667 2.5Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1667 11.6667H13C12.5333 11.6667 12.2999 11.6667 12.1217 11.7575C11.9649 11.8374 11.8374 11.9649 11.7575 12.1217C11.6667 12.2999 11.6667 12.5333 11.6667 13V16.1667C11.6667 16.6334 11.6667 16.8667 11.7575 17.045C11.8374 17.2018 11.9649 17.3293 12.1217 17.4092C12.2999 17.5 12.5333 17.5 13 17.5H16.1667C16.6334 17.5 16.8667 17.5 17.045 17.4092C17.2018 17.3293 17.3293 17.2018 17.4092 17.045C17.5 16.8667 17.5 16.6334 17.5 16.1667V13C17.5 12.5333 17.5 12.2999 17.4092 12.1217C17.3293 11.9649 17.2018 11.8374 17.045 11.7575C16.8667 11.6667 16.6334 11.6667 16.1667 11.6667Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11.6667H3.83333C3.36662 11.6667 3.13327 11.6667 2.95501 11.7575C2.79821 11.8374 2.67072 11.9649 2.59083 12.1217C2.5 12.2999 2.5 12.5333 2.5 13V16.1667C2.5 16.6334 2.5 16.8667 2.59083 17.045C2.67072 17.2018 2.79821 17.3293 2.95501 17.4092C3.13327 17.5 3.36662 17.5 3.83333 17.5H7C7.46671 17.5 7.70007 17.5 7.87833 17.4092C8.03513 17.3293 8.16261 17.2018 8.24251 17.045C8.33333 16.8667 8.33333 16.6334 8.33333 16.1667V13C8.33333 12.5333 8.33333 12.2999 8.24251 12.1217C8.16261 11.9649 8.03513 11.8374 7.87833 11.7575C7.70007 11.6667 7.46671 11.6667 7 11.6667Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MedicalCrossIcon = ({ color }: { color?: "green" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 3.83333C12.5 3.36662 12.5 3.13327 12.4092 2.95501C12.3293 2.79821 12.2018 2.67072 12.045 2.59083C11.8667 2.5 11.6334 2.5 11.1667 2.5H8.83333C8.36662 2.5 8.13327 2.5 7.95501 2.59083C7.79821 2.67072 7.67072 2.79821 7.59083 2.95501C7.5 3.13327 7.5 3.36662 7.5 3.83333V6.16667C7.5 6.63338 7.5 6.86673 7.40917 7.04499C7.32928 7.20179 7.20179 7.32928 7.04499 7.40917C6.86673 7.5 6.63338 7.5 6.16667 7.5H3.83333C3.36662 7.5 3.13327 7.5 2.95501 7.59083C2.79821 7.67072 2.67072 7.79821 2.59083 7.95501C2.5 8.13327 2.5 8.36662 2.5 8.83333V11.1667C2.5 11.6334 2.5 11.8667 2.59083 12.045C2.67072 12.2018 2.79821 12.3293 2.95501 12.4092C3.13327 12.5 3.36662 12.5 3.83333 12.5H6.16667C6.63338 12.5 6.86673 12.5 7.04499 12.5908C7.20179 12.6707 7.32928 12.7982 7.40917 12.955C7.5 13.1333 7.5 13.3666 7.5 13.8333V16.1667C7.5 16.6334 7.5 16.8667 7.59083 17.045C7.67072 17.2018 7.79821 17.3293 7.95501 17.4092C8.13327 17.5 8.36662 17.5 8.83333 17.5H11.1667C11.6334 17.5 11.8667 17.5 12.045 17.4092C12.2018 17.3293 12.3293 17.2018 12.4092 17.045C12.5 16.8667 12.5 16.6334 12.5 16.1667V13.8333C12.5 13.3666 12.5 13.1333 12.5908 12.955C12.6707 12.7982 12.7982 12.6707 12.955 12.5908C13.1333 12.5 13.3666 12.5 13.8333 12.5H16.1667C16.6334 12.5 16.8667 12.5 17.045 12.4092C17.2018 12.3293 17.3293 12.2018 17.4092 12.045C17.5 11.8667 17.5 11.6334 17.5 11.1667V8.83333C17.5 8.36662 17.5 8.13327 17.4092 7.95501C17.3293 7.79821 17.2018 7.67072 17.045 7.59083C16.8667 7.5 16.6334 7.5 16.1667 7.5L13.8333 7.5C13.3666 7.5 13.1333 7.5 12.955 7.40917C12.7982 7.32928 12.6707 7.20179 12.5908 7.04499C12.5 6.86673 12.5 6.63338 12.5 6.16667V3.83333Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeftIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke={style.mainTextColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ICLMedIcon = () => (
  <svg
    width="89"
    height="19"
    viewBox="0 0 89 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.52 18V1.2H2.92V18H0.52ZM15.4617 18.192C14.1817 18.192 12.9977 17.984 11.9097 17.568C10.8377 17.136 9.90169 16.536 9.10169 15.768C8.31769 14.984 7.70169 14.072 7.25369 13.032C6.80569 11.992 6.58169 10.848 6.58169 9.6C6.58169 8.352 6.80569 7.208 7.25369 6.168C7.70169 5.128 8.32569 4.224 9.12569 3.456C9.92569 2.672 10.8617 2.072 11.9337 1.656C13.0217 1.224 14.2057 1.008 15.4857 1.008C16.7817 1.008 17.9737 1.232 19.0617 1.68C20.1657 2.112 21.1017 2.76 21.8697 3.624L20.3097 5.136C19.6697 4.464 18.9497 3.968 18.1497 3.648C17.3497 3.312 16.4937 3.144 15.5817 3.144C14.6377 3.144 13.7577 3.304 12.9417 3.624C12.1417 3.944 11.4457 4.392 10.8537 4.968C10.2617 5.544 9.79769 6.232 9.46169 7.032C9.14169 7.816 8.98169 8.672 8.98169 9.6C8.98169 10.528 9.14169 11.392 9.46169 12.192C9.79769 12.976 10.2617 13.656 10.8537 14.232C11.4457 14.808 12.1417 15.256 12.9417 15.576C13.7577 15.896 14.6377 16.056 15.5817 16.056C16.4937 16.056 17.3497 15.896 18.1497 15.576C18.9497 15.24 19.6697 14.728 20.3097 14.04L21.8697 15.552C21.1017 16.416 20.1657 17.072 19.0617 17.52C17.9737 17.968 16.7737 18.192 15.4617 18.192ZM25.2934 18V1.2H27.6934V15.912H36.7894V18H25.2934Z"
      fill={style.mainTextColor}
    />
    <path
      d="M39.5434 18V1.2H41.5114L49.0474 13.896H47.9914L55.4314 1.2H57.3994L57.4234 18H55.1194L55.0954 4.824H55.6474L49.0234 15.96H47.9194L41.2474 4.824H41.8474V18H39.5434ZM67.7933 18.144C66.4333 18.144 65.2333 17.864 64.1933 17.304C63.1693 16.744 62.3693 15.976 61.7933 15C61.2333 14.024 60.9533 12.904 60.9533 11.64C60.9533 10.376 61.2253 9.256 61.7693 8.28C62.3293 7.304 63.0893 6.544 64.0493 6C65.0253 5.44 66.1213 5.16 67.3373 5.16C68.5693 5.16 69.6573 5.432 70.6013 5.976C71.5453 6.52 72.2813 7.288 72.8093 8.28C73.3533 9.256 73.6253 10.4 73.6253 11.712C73.6253 11.808 73.6173 11.92 73.6013 12.048C73.6013 12.176 73.5933 12.296 73.5773 12.408H62.7533V10.752H72.3773L71.4413 11.328C71.4573 10.512 71.2893 9.784 70.9373 9.144C70.5853 8.504 70.0973 8.008 69.4733 7.656C68.8653 7.288 68.1533 7.104 67.3373 7.104C66.5373 7.104 65.8253 7.288 65.2013 7.656C64.5773 8.008 64.0893 8.512 63.7373 9.168C63.3853 9.808 63.2093 10.544 63.2093 11.376V11.76C63.2093 12.608 63.4013 13.368 63.7853 14.04C64.1853 14.696 64.7373 15.208 65.4413 15.576C66.1453 15.944 66.9533 16.128 67.8653 16.128C68.6173 16.128 69.2973 16 69.9053 15.744C70.5293 15.488 71.0733 15.104 71.5373 14.592L72.8093 16.08C72.2333 16.752 71.5133 17.264 70.6493 17.616C69.8013 17.968 68.8493 18.144 67.7933 18.144ZM82.0806 18.144C80.8486 18.144 79.7446 17.872 78.7686 17.328C77.8086 16.784 77.0486 16.024 76.4886 15.048C75.9286 14.072 75.6486 12.936 75.6486 11.64C75.6486 10.344 75.9286 9.216 76.4886 8.256C77.0486 7.28 77.8086 6.52 78.7686 5.976C79.7446 5.432 80.8486 5.16 82.0806 5.16C83.1526 5.16 84.1206 5.4 84.9846 5.88C85.8486 6.36 86.5366 7.08 87.0486 8.04C87.5766 9 87.8406 10.2 87.8406 11.64C87.8406 13.08 87.5846 14.28 87.0726 15.24C86.5766 16.2 85.8966 16.928 85.0326 17.424C84.1686 17.904 83.1846 18.144 82.0806 18.144ZM82.2726 16.128C83.0726 16.128 83.7926 15.944 84.4326 15.576C85.0886 15.208 85.6006 14.688 85.9686 14.016C86.3526 13.328 86.5446 12.536 86.5446 11.64C86.5446 10.728 86.3526 9.944 85.9686 9.288C85.6006 8.616 85.0886 8.096 84.4326 7.728C83.7926 7.36 83.0726 7.176 82.2726 7.176C81.4566 7.176 80.7286 7.36 80.0886 7.728C79.4486 8.096 78.9366 8.616 78.5526 9.288C78.1686 9.944 77.9766 10.728 77.9766 11.64C77.9766 12.536 78.1686 13.328 78.5526 14.016C78.9366 14.688 79.4486 15.208 80.0886 15.576C80.7286 15.944 81.4566 16.128 82.2726 16.128ZM86.6166 18V14.568L86.7606 11.616L86.5206 8.664V0.191999H88.8246V18H86.6166Z"
      fill="#67D394"
    />
  </svg>
);

export const UsersIcon = ({ color }: { color?: "green" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 2.8898C14.5681 3.50343 15.4166 4.77762 15.4166 6.25C15.4166 7.72238 14.5681 8.99657 13.3333 9.6102M15 13.972C16.2595 14.5419 17.3937 15.4708 18.3333 16.6667M1.66663 16.6667C3.2887 14.6021 5.49094 13.3333 7.91663 13.3333C10.3423 13.3333 12.5446 14.6021 14.1666 16.6667M11.6666 6.25C11.6666 8.32107 9.98769 10 7.91663 10C5.84556 10 4.16663 8.32107 4.16663 6.25C4.16663 4.17893 5.84556 2.5 7.91663 2.5C9.98769 2.5 11.6666 4.17893 11.6666 6.25Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookOpenIcon = ({ color }: { color?: "green" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99996 16.6663H4.33329C3.39987 16.6663 2.93316 16.6663 2.57664 16.4847C2.26304 16.3249 2.00807 16.0699 1.84828 15.7563C1.66663 15.3998 1.66663 14.9331 1.66663 13.9997V5.99967C1.66663 5.06625 1.66663 4.59954 1.84828 4.24302C2.00807 3.92942 2.26304 3.67445 2.57664 3.51466C2.93316 3.33301 3.39987 3.33301 4.33329 3.33301H4.66663C6.53347 3.33301 7.46689 3.33301 8.17993 3.69632C8.80713 4.0159 9.31707 4.52583 9.63665 5.15304C9.99996 5.86608 9.99996 6.7995 9.99996 8.66634M9.99996 16.6663V8.66634M9.99996 16.6663H15.6666C16.6 16.6663 17.0668 16.6663 17.4233 16.4847C17.7369 16.3249 17.9918 16.0699 18.1516 15.7563C18.3333 15.3998 18.3333 14.9331 18.3333 13.9997V5.99967C18.3333 5.06625 18.3333 4.59954 18.1516 4.24302C17.9918 3.92942 17.7369 3.67445 17.4233 3.51466C17.0668 3.33301 16.6 3.33301 15.6666 3.33301H15.3333C13.4665 3.33301 12.533 3.33301 11.82 3.69632C11.1928 4.0159 10.6828 4.52583 10.3633 5.15304C9.99996 5.86608 9.99996 6.7995 9.99996 8.66634"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileIcon = ({ color }: { color?: "green" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6667 1.8916V5.33372C11.6667 5.80043 11.6667 6.03378 11.7575 6.21204C11.8374 6.36885 11.9649 6.49633 12.1217 6.57622C12.3 6.66705 12.5333 6.66705 13 6.66705H16.4422M13.3334 10.8337H6.66671M13.3334 14.167H6.66671M8.33337 7.50033H6.66671M11.6667 1.66699H7.33337C5.93324 1.66699 5.23318 1.66699 4.6984 1.93948C4.22799 2.17916 3.84554 2.56161 3.60586 3.03202C3.33337 3.5668 3.33337 4.26686 3.33337 5.66699V14.3337C3.33337 15.7338 3.33337 16.4339 3.60586 16.9686C3.84554 17.439 4.22799 17.8215 4.6984 18.0612C5.23318 18.3337 5.93324 18.3337 7.33337 18.3337H12.6667C14.0668 18.3337 14.7669 18.3337 15.3017 18.0612C15.7721 17.8215 16.1545 17.439 16.3942 16.9686C16.6667 16.4339 16.6667 15.7338 16.6667 14.3337V6.66699L11.6667 1.66699Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AnnotationQuestionIcon = ({ color }: { color?: "green" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33333 7.0852C8.48016 6.6678 8.76998 6.31584 9.15144 6.09165C9.53291 5.86745 9.98141 5.7855 10.4175 5.86031C10.8536 5.93511 11.2492 6.16184 11.5341 6.50034C11.8191 6.83884 11.975 7.26726 11.9744 7.70973C11.9744 8.9588 10.1008 9.58333 10.1008 9.58333M10.1249 12.0833H10.1333M8.25 16L9.46667 17.6222C9.6476 17.8635 9.73807 17.9841 9.84897 18.0272C9.94611 18.065 10.0539 18.065 10.151 18.0272C10.2619 17.9841 10.3524 17.8635 10.5333 17.6222L11.75 16C11.9943 15.6743 12.1164 15.5114 12.2654 15.3871C12.4641 15.2213 12.6986 15.104 12.9504 15.0446C13.1393 15 13.3429 15 13.75 15C14.9149 15 15.4973 15 15.9567 14.8097C16.5693 14.556 17.056 14.0693 17.3097 13.4567C17.5 12.9973 17.5 12.4149 17.5 11.25V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V11.25C2.5 12.4149 2.5 12.9973 2.6903 13.4567C2.94404 14.0693 3.43072 14.556 4.04329 14.8097C4.50272 15 5.08515 15 6.25 15C6.65715 15 6.86072 15 7.04959 15.0446C7.30141 15.104 7.53593 15.2213 7.73458 15.3871C7.88357 15.5114 8.00571 15.6743 8.25 16Z"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadMediaIcon = ({ color }: { color?: "green" | "grey" }) => (
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1667 10.417V5.66699C15.1667 4.26686 15.1667 3.5668 14.8942 3.03202C14.6545 2.56161 14.2721 2.17916 13.8017 1.93948C13.2669 1.66699 12.5668 1.66699 11.1667 1.66699H5.83337C4.43324 1.66699 3.73318 1.66699 3.1984 1.93948C2.72799 2.17916 2.34554 2.56161 2.10586 3.03202C1.83337 3.5668 1.83337 4.26686 1.83337 5.66699V14.3337C1.83337 15.7338 1.83337 16.4339 2.10586 16.9686C2.34554 17.439 2.72799 17.8215 3.1984 18.0612C3.73318 18.3337 4.4332 18.3337 5.83326 18.3337H8.91671M10.1667 9.16699H5.16671M6.83337 12.5003H5.16671M11.8334 5.83366H5.16671M11 15.8337L13.5 18.3337M13.5 18.3337L16 15.8337M13.5 18.3337V13.3337"
      stroke={color === "green" ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 14.75L12.1251 12.125M14 7.625C14 11.1458 11.1458 14 7.625 14C4.10418 14 1.25 11.1458 1.25 7.625C1.25 4.10418 4.10418 1.25 7.625 1.25C11.1458 1.25 14 4.10418 14 7.625Z"
      stroke="#85879B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchInputIcon = ({ className }: { className: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.5 16.5L12.875 12.875M8.16667 4C10.4679 4 12.3333 5.86548 12.3333 8.16667M14.8333 8.16667C14.8333 11.8486 11.8486 14.8333 8.16667 14.8333C4.48477 14.8333 1.5 11.8486 1.5 8.16667C1.5 4.48477 4.48477 1.5 8.16667 1.5C11.8486 1.5 14.8333 4.48477 14.8333 8.16667Z"
      stroke="#85879B"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 2.45C1.5 2.02996 1.5 1.81994 1.58175 1.65951C1.65365 1.51839 1.76839 1.40365 1.90951 1.33175C2.06994 1.25 2.27996 1.25 2.7 1.25H15.3C15.72 1.25 15.9301 1.25 16.0905 1.33175C16.2316 1.40365 16.3463 1.51839 16.4183 1.65951C16.5 1.81994 16.5 2.02996 16.5 2.45V2.95205C16.5 3.15364 16.5 3.25444 16.4754 3.34817C16.4535 3.43123 16.4176 3.50993 16.3691 3.58082C16.3144 3.66082 16.2383 3.72684 16.0859 3.85887L11.2891 8.01613C11.1367 8.14816 11.0606 8.21418 11.0059 8.29418C10.9574 8.36507 10.9215 8.44377 10.8996 8.52683C10.875 8.62056 10.875 8.72136 10.875 8.92295V12.8438C10.875 12.9905 10.875 13.0638 10.8513 13.1272C10.8304 13.1832 10.7964 13.2334 10.7522 13.2736C10.7021 13.3192 10.634 13.3464 10.4978 13.4009L7.94783 14.4209C7.67218 14.5311 7.53435 14.5863 7.4237 14.5633C7.32695 14.5432 7.24204 14.4857 7.18744 14.4033C7.125 14.3091 7.125 14.1607 7.125 13.8638V8.92295C7.125 8.72136 7.125 8.62056 7.10037 8.52683C7.07854 8.44377 7.0426 8.36507 6.99413 8.29418C6.93943 8.21418 6.86326 8.14816 6.71092 8.01613L1.91408 3.85887C1.76174 3.72684 1.68557 3.66082 1.63087 3.58082C1.5824 3.50993 1.54646 3.43123 1.52463 3.34817C1.5 3.25444 1.5 3.15364 1.5 2.95205V2.45Z"
      stroke="#85879B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XCloseIcon = ({ color = "default" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
      stroke={
        color === "green" ? "#67d394" : color === "red" ? "#ff7394" : "#85879B"
      }
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XCircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_10531)">
      <path
        d="M12.4998 7.50033L7.49984 12.5003M7.49984 7.50033L12.4998 12.5003M18.3332 10.0003C18.3332 14.6027 14.6022 18.3337 9.99984 18.3337C5.39746 18.3337 1.6665 14.6027 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003Z"
        stroke="#FF7394"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_10531">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CheckIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4.5L6.75 12.75L3 9"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const CheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     {...props}
//   >
//     <g clipPath="url(#clip0_192_10116)">
//       <path
//         d="M6.24984 10.0003L8.74984 12.5003L13.7498 7.50033M18.3332 10.0003C18.3332 14.6027 14.6022 18.3337 9.99984 18.3337C5.39746 18.3337 1.6665 14.6027 1.6665 10.0003C1.6665 5.39795 5.39746 1.66699 9.99984 1.66699C14.6022 1.66699 18.3332 5.39795 18.3332 10.0003Z"
//         stroke="#67D394"
//         strokeWidth="1.67"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </g>
//     <defs>
//       <clipPath id="clip0_192_10116">
//         <rect width="20" height="20" fill="white" />
//       </clipPath>
//     </defs>
//   </svg>
// );

export const CloseInCircleIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className || ""}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5003 7.5L7.50033 12.5M7.50033 7.5L12.5003 12.5M18.3337 10C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 10C1.66699 5.39762 5.39795 1.66666 10.0003 1.66666C14.6027 1.66666 18.3337 5.39762 18.3337 10Z"
      stroke="#85879B"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EngineeringIcon = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 12.9167H6.25008C5.08711 12.9167 4.50563 12.9167 4.03246 13.0602C2.96713 13.3834 2.13345 14.217 1.81028 15.2824C1.66675 15.7555 1.66675 16.337 1.66675 17.5M12.0834 6.25C12.0834 8.32107 10.4045 10 8.33341 10C6.26235 10 4.58341 8.32107 4.58341 6.25C4.58341 4.17893 6.26235 2.5 8.33341 2.5C10.4045 2.5 12.0834 4.17893 12.0834 6.25Z"
      stroke={color ? "#67D394" : "#85879B"}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8637 13.8452L20.0001 12.8571L19.0837 11.3095L17.6296 11.7738C17.4585 11.6429 17.263 11.5357 17.0553 11.4524L16.7498 10H14.917L14.6115 11.4524C14.4038 11.5357 14.2083 11.6429 14.025 11.7738L12.5832 11.3095L11.6667 12.8571L12.8031 13.8452C12.7787 14.0476 12.7787 14.2619 12.8031 14.4643L11.6667 15.4762L12.5832 17.0238L14.0494 16.5714C14.2083 16.6905 14.3916 16.7857 14.5749 16.869L14.917 18.3333H16.7498L17.0797 16.881C17.2753 16.7976 17.4463 16.7024 17.6174 16.5833L19.0714 17.0357L19.9879 15.4881L18.8515 14.4762C18.8882 14.25 18.8759 14.0476 18.8637 13.8452ZM15.8334 15.6548C14.9903 15.6548 14.306 14.9881 14.306 14.1667C14.306 13.3452 14.9903 12.6786 15.8334 12.6786C16.6765 12.6786 17.3608 13.3452 17.3608 14.1667C17.3608 14.9881 16.6765 15.6548 15.8334 15.6548Z"
      fill={color ? "#67D394" : "#85879B"}
    />
  </svg>
);

export const DownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5 16.5H1.5M14 8.16667L9 13.1667M9 13.1667L4 8.16667M9 13.1667V1.5"
      stroke="#85879B"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="#85879B"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckboxIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className || ""}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.625 8L6.875 10.25L11.375 5.75M4.85 14.75H11.15C12.4101 14.75 13.0402 14.75 13.5215 14.5048C13.9448 14.289 14.289 13.9448 14.5048 13.5215C14.75 13.0402 14.75 12.4101 14.75 11.15V4.85C14.75 3.58988 14.75 2.95982 14.5048 2.47852C14.289 2.05516 13.9448 1.71095 13.5215 1.49524C13.0402 1.25 12.4101 1.25 11.15 1.25H4.85C3.58988 1.25 2.95982 1.25 2.47852 1.49524C2.05516 1.71095 1.71095 2.05516 1.49524 2.47852C1.25 2.95982 1.25 3.58988 1.25 4.85V11.15C1.25 12.4101 1.25 13.0402 1.49524 13.5215C1.71095 13.9448 2.05516 14.289 2.47852 14.5048C2.95982 14.75 3.58988 14.75 4.85 14.75Z"
      stroke="#67D394"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckboxNotIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className={className || ""}
  >
    <path
      id="svg_1"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="1.5"
      stroke="#85879B"
      d="m4.85,14.75l6.3,0c1.2601,0 1.8902,0 2.3715,-0.2452c0.4233,-0.2158 0.7675,-0.56 0.9833,-0.9833c0.2452,-0.4813 0.2452,-1.1114 0.2452,-2.3715l0,-6.3c0,-1.26012 0,-1.89018 -0.2452,-2.37148c-0.2158,-0.42336 -0.56,-0.76757 -0.9833,-0.98328c-0.4813,-0.24524 -1.1114,-0.24524 -2.3715,-0.24524l-6.3,0c-1.26012,0 -1.89018,0 -2.37148,0.24524c-0.42336,0.21571 -0.76757,0.55992 -0.98328,0.98328c-0.24524,0.4813 -0.24524,1.11136 -0.24524,2.37148l0,6.3c0,1.2601 0,1.8902 0.24524,2.3715c0.21571,0.4233 0.55992,0.7675 0.98328,0.9833c0.4813,0.2452 1.11136,0.2452 2.37148,0.2452z"
    />
  </svg>
);

export const SortArrowUpIcon = ({ color }: { color?: string }) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.28274 0.295314C4.49064 0.108204 4.72973 0.0146484 5 0.0146484C5.27027 0.0146484 5.50936 0.108204 5.71726 0.295314L9.70894 4.287C10 4.61964 10.0728 4.98346 9.92724 5.37847C9.74012 5.77348 9.42828 5.98139 8.99168 6.00218H1.00832C0.571726 5.98139 0.259875 5.77348 0.0727651 5.37847C-0.0727651 4.98346 0 4.61964 0.29106 4.287L4.28274 0.295314Z"
      fill={color ? "#67D394" : "#E7E8F1"}
    />
  </svg>
);

export const SortArrowDownIcon = ({ color }: { color?: string }) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.28274 6.70491L0.29106 2.71322C0 2.38058 -0.0727651 2.01676 0.0727651 1.62175C0.259875 1.22674 0.571726 1.01884 1.00832 0.998047H8.99168C9.42828 1.01884 9.74012 1.22674 9.92724 1.62175C10.0728 2.01676 10 2.38058 9.70894 2.71322L5.71726 6.70491C5.50936 6.89202 5.27027 6.98557 5 6.98557C4.72973 6.98557 4.49064 6.89202 4.28274 6.70491Z"
      fill={color === "green" ? "#67D394" : "#E7E8F1"}
    />
  </svg>
);

export const PaginationLeftExpressIcon = () => (
  <svg
    width="11"
    height="8"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 7.33334L6.16667 4L9.5 0.666672M4.83333 7.33334L1.5 4L4.83333 0.666672"
      stroke="#85879B"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaginationRightExpressIcon = () => (
  <svg
    width="11"
    height="8"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 7.33334L4.83333 4L1.5 0.666672M6.16667 7.33334L9.5 4L6.16667 0.666672"
      stroke="#85879B"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaginationLeftIcon = () => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 9L1.5 5L5.5 1"
      stroke="#85879B"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaginationRightIcon = () => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9L5.5 5L1.5 1"
      stroke="#85879B"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MusicIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className || ""}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 12.5V3.76652C5.75 3.40537 5.75 3.2248 5.8157 3.07834C5.87362 2.94924 5.96687 2.83915 6.0847 2.7608C6.21836 2.67191 6.39648 2.64223 6.75272 2.58285L13.3527 1.48285C13.8334 1.40273 14.0738 1.36267 14.2611 1.43225C14.4255 1.49331 14.5633 1.61004 14.6506 1.76215C14.75 1.93549 14.75 2.17917 14.75 2.66653V11M5.75 12.5C5.75 13.7426 4.74264 14.75 3.5 14.75C2.25736 14.75 1.25 13.7426 1.25 12.5C1.25 11.2573 2.25736 10.25 3.5 10.25C4.74264 10.25 5.75 11.2573 5.75 12.5ZM14.75 11C14.75 12.2426 13.7426 13.25 12.5 13.25C11.2574 13.25 10.25 12.2426 10.25 11C10.25 9.75733 11.2574 8.74997 12.5 8.74997C13.7426 8.74997 14.75 9.75733 14.75 11Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 8.33366H2.5M13.3333 1.66699V5.00033M6.66667 1.66699V5.00033M6.5 18.3337H13.5C14.9001 18.3337 15.6002 18.3337 16.135 18.0612C16.6054 17.8215 16.9878 17.439 17.2275 16.9686C17.5 16.4339 17.5 15.7338 17.5 14.3337V7.33366C17.5 5.93353 17.5 5.23346 17.2275 4.69868C16.9878 4.22828 16.6054 3.84583 16.135 3.60614C15.6002 3.33366 14.9001 3.33366 13.5 3.33366H6.5C5.09987 3.33366 4.3998 3.33366 3.86502 3.60614C3.39462 3.84583 3.01217 4.22828 2.77248 4.69868C2.5 5.23346 2.5 5.93353 2.5 7.33366V14.3337C2.5 15.7338 2.5 16.4339 2.77248 16.9686C3.01217 17.439 3.39462 17.8215 3.86502 18.0612C4.3998 18.3337 5.09987 18.3337 6.5 18.3337Z"
      stroke={props.color === "grey" ? "#85879B" : style.mainTextColor}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const PhoneIcon = ({ color }: { color?: string }) => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M6.98356 7.37779C7.56356 8.58581 8.35422 9.71801 9.35553 10.7193C10.3568 11.7206 11.4891 12.5113 12.6971 13.0913C12.801 13.1412 12.8529 13.1661 12.9187 13.1853C13.1523 13.2534 13.4392 13.2045 13.637 13.0628C13.6927 13.0229 13.7403 12.9753 13.8356 12.88C14.1269 12.5887 14.2726 12.443 14.4191 12.3478C14.9715 11.9886 15.6837 11.9886 16.2361 12.3478C16.3825 12.443 16.5282 12.5887 16.8196 12.88L16.9819 13.0424C17.4248 13.4853 17.6462 13.7067 17.7665 13.9446C18.0058 14.4175 18.0058 14.9761 17.7665 15.449C17.6462 15.6869 17.4248 15.9083 16.9819 16.3512L16.8506 16.4825C16.4092 16.9239 16.1886 17.1446 15.8885 17.3131C15.5556 17.5001 15.0385 17.6346 14.6567 17.6334C14.3126 17.6324 14.0774 17.5657 13.607 17.4322C11.0792 16.7147 8.69387 15.361 6.70388 13.371C4.7139 11.381 3.36017 8.99569 2.6427 6.46786C2.50919 5.99749 2.44244 5.7623 2.44141 5.41818C2.44028 5.03633 2.57475 4.51925 2.76176 4.18633C2.9303 3.88631 3.15098 3.66563 3.59233 3.22428L3.72369 3.09292C4.16656 2.65005 4.388 2.42861 4.62581 2.30833C5.09878 2.0691 5.65734 2.0691 6.1303 2.30832C6.36812 2.42861 6.58955 2.65005 7.03242 3.09291L7.19481 3.25531C7.48615 3.54665 7.63182 3.69231 7.72706 3.8388C8.08622 4.3912 8.08622 5.10335 7.72706 5.65576C7.63182 5.80225 7.48615 5.94791 7.19481 6.23925C7.09955 6.33451 7.05192 6.38214 7.01206 6.43782C6.87038 6.63568 6.82146 6.92256 6.88957 7.15619C6.90873 7.22193 6.93367 7.27389 6.98356 7.37779Z"
//       stroke={color === "green" ? "#67D394" : style.mainTextColor}
//       strokeWidth="1.66667"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

export const BellIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0383 15.0126C13.3956 16.3462 12.6042 17.7171 11.2705 18.0744C9.93684 18.4318 8.566 17.6403 8.20864 16.3067M1.71404 9.678C1.38946 8.51285 1.72699 7.25315 2.59066 6.40639M10.1219 4.78428C10.3754 4.3282 10.4589 3.77695 10.3132 3.23312C10.0154 2.12173 8.87307 1.46219 7.76168 1.75998C6.65029 2.05778 5.99074 3.20015 6.28854 4.31153C6.43426 4.85536 6.7822 5.29101 7.22979 5.55923M16.9325 5.60024C16.631 4.4289 15.7089 3.50674 14.5375 3.20526M14.5755 7.87131C14.2781 6.7612 13.484 5.8329 12.3679 5.29062C11.2519 4.74834 9.90525 4.63651 8.62436 4.97973C7.34346 5.32294 6.23319 6.09309 5.53779 7.12075C4.84239 8.14841 4.61882 9.34939 4.91628 10.4595C5.40842 12.2962 5.31286 13.7615 5.00206 14.875C4.64784 16.144 4.47073 16.7785 4.51858 16.906C4.57332 17.0517 4.61292 17.0917 4.75812 17.148C4.88503 17.1972 5.41817 17.0543 6.48445 16.7686L16.372 14.1192C17.4383 13.8335 17.9714 13.6907 18.0568 13.5846C18.1544 13.4633 18.1687 13.4089 18.1432 13.2553C18.1209 13.121 17.6503 12.66 16.709 11.7381C15.8831 10.9292 15.0677 9.70802 14.5755 7.87131Z"
      stroke={style.mainTextColor}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_7480)">
      <path
        d="M9 4.5V9L12 10.5M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="#67D394"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_7480">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MailIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.125 13.5L11.1429 9M6.85714 9L1.87503 13.5M1.5 5.25L7.62369 9.53658C8.11957 9.8837 8.36751 10.0573 8.6372 10.1245C8.87542 10.1839 9.12458 10.1839 9.3628 10.1245C9.63249 10.0573 9.88043 9.8837 10.3763 9.53658L16.5 5.25M5.1 15H12.9C14.1601 15 14.7902 15 15.2715 14.7548C15.6948 14.539 16.039 14.1948 16.2548 13.7715C16.5 13.2902 16.5 12.6601 16.5 11.4V6.6C16.5 5.33988 16.5 4.70982 16.2548 4.22852C16.039 3.80516 15.6948 3.46095 15.2715 3.24524C14.7902 3 14.1601 3 12.9 3H5.1C3.83988 3 3.20982 3 2.72852 3.24524C2.30516 3.46095 1.96095 3.80516 1.74524 4.22852C1.5 4.70982 1.5 5.33988 1.5 6.6V11.4C1.5 12.6601 1.5 13.2902 1.74524 13.7715C1.96095 14.1948 2.30516 14.539 2.72852 14.7548C3.20982 15 3.83988 15 5.1 15Z"
      stroke="#67D394"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AvatarIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_8230)">
      <path
        d="M4.49927 29.5936C4.49927 25.6171 7.72282 22.3936 11.6993 22.3936H24.2993C28.2757 22.3936 31.4993 25.6171 31.4993 29.5936V42.1936C31.4993 46.17 28.2757 49.3936 24.2993 49.3936H11.6993C7.72282 49.3936 4.49927 46.17 4.49927 42.1936V29.5936Z"
        fill="#7DB2F1"
      />
      <path
        d="M4.49927 29.5936C4.49927 25.6171 7.72282 22.3936 11.6993 22.3936H24.2993C28.2757 22.3936 31.4993 25.6171 31.4993 29.5936V42.1936C31.4993 46.17 28.2757 49.3936 24.2993 49.3936H11.6993C7.72282 49.3936 4.49927 46.17 4.49927 42.1936V29.5936Z"
        fill="white"
        fillOpacity="0.16"
      />
      <ellipse cx="17.9993" cy="12.6004" rx="7.2" ry="7.2" fill="#7DB2F1" />
      <ellipse
        cx="17.9993"
        cy="12.6004"
        rx="7.2"
        ry="7.2"
        fill="white"
        fillOpacity="0.16"
      />
    </g>
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="#7DB2F1"
      strokeWidth="2"
    />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="17"
      stroke="white"
      strokeOpacity="0.16"
      strokeWidth="2"
    />
    <defs>
      <clipPath id="clip0_192_8230">
        <rect width="36" height="36" rx="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserCircleIcon = ({ color }: { color?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_10580)">
      <path
        d="M3.54387 12.9596C3.94942 12.0041 4.89629 11.334 5.99967 11.334H9.99967C11.1031 11.334 12.0499 12.0041 12.4555 12.9596M10.6663 6.33398C10.6663 7.80674 9.47243 9.00065 7.99967 9.00065C6.52692 9.00065 5.33301 7.80674 5.33301 6.33398C5.33301 4.86123 6.52692 3.66732 7.99967 3.66732C9.47243 3.66732 10.6663 4.86123 10.6663 6.33398ZM14.6663 8.00065C14.6663 11.6826 11.6816 14.6673 7.99967 14.6673C4.31778 14.6673 1.33301 11.6826 1.33301 8.00065C1.33301 4.31875 4.31778 1.33398 7.99967 1.33398C11.6816 1.33398 14.6663 4.31875 14.6663 8.00065Z"
        stroke="#85879B"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_10580">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LogoutIcon = ({ color }: { color?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6M6 2H5.2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2V10.8C2 11.9201 2 12.4802 2.21799 12.908C2.40973 13.2843 2.71569 13.5903 3.09202 13.782C3.51984 14 4.0799 14 5.2 14H6"
      stroke="#85879B"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PrinterIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_192_12528)">
      <path
        d="M13.5 5.25V3.9C13.5 3.05992 13.5 2.63988 13.3365 2.31901C13.1927 2.03677 12.9632 1.8073 12.681 1.66349C12.3601 1.5 11.9401 1.5 11.1 1.5H6.9C6.05992 1.5 5.63988 1.5 5.31901 1.66349C5.03677 1.8073 4.8073 2.03677 4.66349 2.31901C4.5 2.63988 4.5 3.05992 4.5 3.9V5.25M4.5 13.5C3.80252 13.5 3.45378 13.5 3.16766 13.4233C2.3912 13.2153 1.78472 12.6088 1.57667 11.8323C1.5 11.5462 1.5 11.1975 1.5 10.5V8.85C1.5 7.58988 1.5 6.95982 1.74524 6.47852C1.96095 6.05516 2.30516 5.71095 2.72852 5.49524C3.20982 5.25 3.83988 5.25 5.1 5.25H12.9C14.1601 5.25 14.7902 5.25 15.2715 5.49524C15.6948 5.71095 16.039 6.05516 16.2548 6.47852C16.5 6.95982 16.5 7.58988 16.5 8.85V10.5C16.5 11.1975 16.5 11.5462 16.4233 11.8323C16.2153 12.6088 15.6088 13.2153 14.8323 13.4233C14.5462 13.5 14.1975 13.5 13.5 13.5M11.25 7.875H13.5M6.9 16.5H11.1C11.9401 16.5 12.3601 16.5 12.681 16.3365C12.9632 16.1927 13.1927 15.9632 13.3365 15.681C13.5 15.3601 13.5 14.9401 13.5 14.1V12.9C13.5 12.0599 13.5 11.6399 13.3365 11.319C13.1927 11.0368 12.9632 10.8073 12.681 10.6635C12.3601 10.5 11.9401 10.5 11.1 10.5H6.9C6.05992 10.5 5.63988 10.5 5.31901 10.6635C5.03677 10.8073 4.8073 11.0368 4.66349 11.319C4.5 11.6399 4.5 12.0599 4.5 12.9V14.1C4.5 14.9401 4.5 15.3601 4.66349 15.681C4.8073 15.9632 5.03677 16.1927 5.31901 16.3365C5.63988 16.5 6.05992 16.5 6.9 16.5Z"
        stroke="#85879B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_192_12528">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlayIcon = ({ className }: { className?: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className={className || ""}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 3.74262C3.75 3.01425 3.75 2.65006 3.90187 2.44931C4.03417 2.27442 4.23639 2.16619 4.4553 2.15312C4.70658 2.13812 5.0096 2.34013 5.61564 2.74416L13.5023 8.00194C14.0031 8.33578 14.2535 8.50271 14.3407 8.7131C14.417 8.89704 14.417 9.10376 14.3407 9.2877C14.2535 9.4981 14.0031 9.66502 13.5023 9.99886L5.61564 15.2566C5.0096 15.6607 4.70658 15.8627 4.4553 15.8477C4.23639 15.8346 4.03417 15.7264 3.90187 15.5515C3.75 15.3507 3.75 14.9866 3.75 14.2582V3.74262Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DotsVerticalIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className || ""}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99967 8.66699C8.36786 8.66699 8.66634 8.36852 8.66634 8.00033C8.66634 7.63214 8.36786 7.33366 7.99967 7.33366C7.63148 7.33366 7.33301 7.63214 7.33301 8.00033C7.33301 8.36852 7.63148 8.66699 7.99967 8.66699Z"
      stroke="#85879B"
      strokeWidth="1.11111"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99967 4.00033C8.36786 4.00033 8.66634 3.70185 8.66634 3.33366C8.66634 2.96547 8.36786 2.66699 7.99967 2.66699C7.63148 2.66699 7.33301 2.96547 7.33301 3.33366C7.33301 3.70185 7.63148 4.00033 7.99967 4.00033Z"
      stroke="#85879B"
      strokeWidth="1.11111"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99967 13.3337C8.36786 13.3337 8.66634 13.0352 8.66634 12.667C8.66634 12.2988 8.36786 12.0003 7.99967 12.0003C7.63148 12.0003 7.33301 12.2988 7.33301 12.667C7.33301 13.0352 7.63148 13.3337 7.99967 13.3337Z"
      stroke="#85879B"
      strokeWidth="1.11111"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const DownloadIcon = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 18 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M15.75 15.75H2.25M13.5 8.25L9 12.75M9 12.75L4.5 8.25M9 12.75V2.25"
//       stroke="#85879B"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const LoginInputIcon = () => (
//   <svg
//     width="20"
//     height="18"
//     viewBox="0 0 20 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M15.8334 16.5L18.3334 14M18.3334 14L15.8334 11.5M18.3334 14H13.3334M12.9167 1.7423C14.1383 2.23679 15 3.43443 15 4.83333C15 6.23224 14.1383 7.42988 12.9167 7.92437M10 11.5H6.66669C5.11355 11.5 4.33698 11.5 3.72441 11.7537C2.90765 12.092 2.25874 12.741 1.92042 13.5577C1.66669 14.1703 1.66669 14.9469 1.66669 16.5M11.25 4.83333C11.25 6.67428 9.75764 8.16667 7.91669 8.16667C6.07574 8.16667 4.58335 6.67428 4.58335 4.83333C4.58335 2.99238 6.07574 1.5 7.91669 1.5C9.75764 1.5 11.25 2.99238 11.25 4.83333Z"
//       stroke="#85879B"
//       strokeWidth="1.6"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const InputErrorIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M9.99996 6.66675V10.0001M9.99996 13.3334H10.0083M18.3333 10.0001C18.3333 14.6025 14.6023 18.3334 9.99996 18.3334C5.39759 18.3334 1.66663 14.6025 1.66663 10.0001C1.66663 5.39771 5.39759 1.66675 9.99996 1.66675C14.6023 1.66675 18.3333 5.39771 18.3333 10.0001Z"
//       stroke="#FF7394"
//       strokeWidth="1.6"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const HiddenIcon = () => (
//   <svg
//     width="20"
//     height="18"
//     viewBox="0 0 20 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M8.95245 3.2436C9.29113 3.19353 9.64051 3.16667 10.0003 3.16667C14.2545 3.16667 17.0461 6.9207 17.9839 8.40569C18.0974 8.58542 18.1542 8.67528 18.1859 8.81389C18.2098 8.91799 18.2098 9.08222 18.1859 9.18631C18.1541 9.32492 18.097 9.41538 17.9827 9.59631C17.7328 9.99179 17.3518 10.5476 16.8471 11.1504M5.6036 4.59586C3.80187 5.81808 2.57871 7.51615 2.01759 8.4044C1.90357 8.58489 1.84656 8.67514 1.81478 8.81373C1.79091 8.91783 1.7909 9.08203 1.81476 9.18613C1.84652 9.32473 1.90328 9.41459 2.01678 9.59432C2.95462 11.0793 5.74618 14.8333 10.0003 14.8333C11.7157 14.8333 13.1932 14.223 14.4073 13.3972M2.50035 1.5L17.5003 16.5M8.23258 7.23223C7.78017 7.68464 7.50035 8.30964 7.50035 9C7.50035 10.3807 8.61963 11.5 10.0003 11.5C10.6907 11.5 11.3157 11.2202 11.7681 10.7678"
//       stroke="#85879B"
//       strokeWidth="1.6"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const CheckboxSelectedIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M4.625 8L6.875 10.25L11.375 5.75M4.85 14.75H11.15C12.4101 14.75 13.0402 14.75 13.5215 14.5048C13.9448 14.289 14.289 13.9448 14.5048 13.5215C14.75 13.0402 14.75 12.4101 14.75 11.15V4.85C14.75 3.58988 14.75 2.95982 14.5048 2.47852C14.289 2.05516 13.9448 1.71095 13.5215 1.49524C13.0402 1.25 12.4101 1.25 11.15 1.25H4.85C3.58988 1.25 2.95982 1.25 2.47852 1.49524C2.05516 1.71095 1.71095 2.05516 1.49524 2.47852C1.25 2.95982 1.25 3.58988 1.25 4.85V11.15C1.25 12.4101 1.25 13.0402 1.49524 13.5215C1.71095 13.9448 2.05516 14.289 2.47852 14.5048C2.95982 14.75 3.58988 14.75 4.85 14.75Z"
//       stroke="#67D394"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export const CheckboxNotSelectedIcon = () => (
//   <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="none">
//     <path
//       id="svg_1"
//       strokeLinejoin="round"
//       strokeLinecap="round"
//       strokeWidth="1.5"
//       stroke="#85879B"
//       d="m4.85,14.75l6.3,0c1.2601,0 1.8902,0 2.3715,-0.2452c0.4233,-0.2158 0.7675,-0.56 0.9833,-0.9833c0.2452,-0.4813 0.2452,-1.1114 0.2452,-2.3715l0,-6.3c0,-1.26012 0,-1.89018 -0.2452,-2.37148c-0.2158,-0.42336 -0.56,-0.76757 -0.9833,-0.98328c-0.4813,-0.24524 -1.1114,-0.24524 -2.3715,-0.24524l-6.3,0c-1.26012,0 -1.89018,0 -2.37148,0.24524c-0.42336,0.21571 -0.76757,0.55992 -0.98328,0.98328c-0.24524,0.4813 -0.24524,1.11136 -0.24524,2.37148l0,6.3c0,1.2601 0,1.8902 0.24524,2.3715c0.21571,0.4233 0.55992,0.7675 0.98328,0.9833c0.4813,0.2452 1.11136,0.2452 2.37148,0.2452z"
//     />
//   </svg>
// );
